import moment from "moment";
import { Message } from "../interfaces/conversations.interface";
import { ContentMessageType } from "../types/whatsapp-message.types";

export const buildOptimisticSocialMessage = ({
  text,
  from,
  type = "text",
}: {
  text: string;
  from: { id: string; name: string; avatarUrl?: string };
  type?: ContentMessageType;
}): Message => {
  const now = moment();
  return {
    id: `optimistic-${now.valueOf()}`,
    message: text,
    type,
    from: {
      id: from.id,
      name: from.name,
      avatarUrl: from.avatarUrl,
    },
    timestamp: {
      full: now.toISOString(),
      date: now.format("DD MMM YYYY"),
      time: now.format("hh:mm a"),
    },
  };
};
